<template>
  <div class="footer">
      <div class="content-container">
          <h3>关于我们</h3>
          <p style="margin-bottom: 20px;">英国普德精英教育（UKAG）成立于2013年，公司总部位于英国贝德福德（Bedford）。作为英国私立寄宿学校协会（BBSN）的认证会员，是一家根植在英国多年，为中国家长和孩子提供英国低龄留学全套解决方案的教育机构。</p>
          <p>英国普德精英教育（UKAG）成立于2013年，公司总部位于英国贝德福德（Bedford）</p>
          <h3>联系我们</h3>
          <p>UK Academics and Guardianship Ltd (UKAG) :  Bedford I-Kan Business Centre, 38 Mill Street, Bedford, England, MK40 3HD</p>
          <p>UK Academics and Guardianship Ltd (UKAG) :  Bedford I-Kan Business Centre, 38 Mill Street, Bedford, England, MK40 3HD</p>
          <p>UK Academics and Guardianship Ltd (UKAG) :  Bedford I-Kan Business Centre, 38 Mill Street, Bedford, England, MK40 3HD</p>
          <p style="margin-top:60px">Copyright © 2013-2020. All rights reserved. </p>
      </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    msg: String
  }
}
</script>


<style lang='scss'  scoped>
.footer{
    background-color: #c5a65d;
    color: #fff;
    padding-bottom: 40px;
    text-align: left;
    h3{
        padding-top:50px;
        font-size: 24px;
        line-height: 40px;
    }
    p{
        font-size: 15px;
    }
}
</style>
